export default __webpack_public_path__ + "media/f190033eda004baf01ec978f29d55616922f1dab057d59309d21630caec349ac.svg";